/* PDP do Harmony Set (templates/product.harmony.liquid), 19/10/2026. */

/* galeria: scroll-snap no mobile, setas + contador, miniaturas no desktop */
(function(){
  var g = document.querySelector('[data-hs-gallery]');
  if (!g) return;
  var track = g.querySelector('[data-hs-slides]');
  var cur = g.querySelector('[data-hs-current]');
  var thumbs = g.querySelectorAll('[data-hs-thumb]');
  var n = track.children.length;
  function idx(){ return Math.round(track.scrollLeft / track.clientWidth); }
  function go(i){
    i = (i + n) % n;
    track.scrollTo({left: i * track.clientWidth, behavior: 'smooth'});
  }
  function sync(){
    var i = idx();
    if (cur) cur.textContent = i + 1;
    thumbs.forEach(function(t, k){ t.classList.toggle('is-active', k === i); });
  }
  track.addEventListener('scroll', function(){ requestAnimationFrame(sync); }, {passive: true});
  var p = g.querySelector('[data-hs-prev]'), nx = g.querySelector('[data-hs-next]');
  if (p) p.addEventListener('click', function(){ go(idx() - 1); });
  if (nx) nx.addEventListener('click', function(){ go(idx() + 1); });
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){ go(parseInt(t.getAttribute('data-hs-thumb'), 10)); });
  });
})();

/* linha do tempo: cada passo abre o modal; a linha enche conforme os passos vistos */
(function(){
  var modal = document.getElementById('hs-tl-modal');
  var steps = document.querySelectorAll('[data-hs-step]');
  if (!modal || !steps.length) return;
  var stages = modal.querySelectorAll('template[data-hs-stage]');
  var body = modal.querySelector('[data-hs-modal-body]');
  var dots = modal.querySelector('[data-hs-dots]');
  var prev = modal.querySelector('[data-hs-mprev]');
  var next = modal.querySelector('[data-hs-mnext]');
  var fill = document.querySelector('[data-hs-tl-fill]');
  var current = 0, highest = -1, opener = null;

  for (var d = 0; d < stages.length; d++) dots.appendChild(document.createElement('i'));

  function render(){
    body.innerHTML = '';
    body.appendChild(stages[current].content.cloneNode(true));
    dots.querySelectorAll('i').forEach(function(el, k){ el.classList.toggle('is-on', k <= current); });
    prev.disabled = current === 0;
    next.textContent = current === stages.length - 1 ? 'Got it' : 'Next →';
    if (current > highest) highest = current;
    steps.forEach(function(s, k){ if (k <= highest) s.classList.add('is-seen'); });
    if (fill) fill.parentNode.style.setProperty('--hs-fill', Math.round(highest / (stages.length - 1) * 100) + '%');
  }
  function open(i){
    opener = document.activeElement;
    current = i; render();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    next.focus();
  }
  function close(){
    modal.hidden = true;
    document.body.style.overflow = '';
    if (opener) opener.focus();
  }
  steps.forEach(function(s){
    s.addEventListener('click', function(){ open(parseInt(s.getAttribute('data-hs-step'), 10)); });
  });
  prev.addEventListener('click', function(){ if (current > 0) { current--; render(); } });
  next.addEventListener('click', function(){
    if (current < stages.length - 1) { current++; render(); } else close();
  });
  modal.querySelector('[data-hs-close]').addEventListener('click', close);
  modal.addEventListener('click', function(e){ if (e.target === modal) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) close(); });
})();

/* abas da comparacao */
(function(){
  var tabs = document.querySelectorAll('[data-hs-tab]');
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      var key = t.getAttribute('data-hs-tab');
      tabs.forEach(function(o){
        var on = o === t;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      document.querySelectorAll('[data-hs-panel]').forEach(function(p){
        p.hidden = p.getAttribute('data-hs-panel') !== key;
      });
    });
  });
})();

/* botoes que levam ao formulario de compra */
(function(){
  document.querySelectorAll('[data-hs-scroll]').forEach(function(a){
    a.addEventListener('click', function(e){
      var f = document.getElementById('hs-buy');
      if (!f) return;
      e.preventDefault();
      f.scrollIntoView({behavior: 'smooth', block: 'center'});
    });
  });
})();

/* barra fixa: aparece so depois que o botao principal sai por cima da tela;
   o clique e repassado ao botao real, sem logica de compra duplicada */
(function(){
  var bar = document.getElementById('hs-sticky');
  var real = document.querySelector('#hs-buy .hs-cta');
  if (!bar || !real) return;
  bar.querySelector('.hs-sticky-btn').addEventListener('click', function(){ real.click(); });
  function sync(){
    var on = real.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    bar.querySelector('.hs-sticky-btn').tabIndex = on ? 0 : -1;
  }
  addEventListener('scroll', sync, {passive: true});
  addEventListener('resize', sync);
  sync();
})();

/* compra: o kit + 1 ebook gratis, direto para o checkout.
   Mesmo desenho do cw-pdp.js (PDP do gerador): o kit entra por add.js e o ebook
   por update.js, que crava exatamente 1. A compra SUBSTITUI o carrinho via
   window.carrinhoSubstitui (assets/carrinho-substitui.js), que esvazia antes e
   confere no fim. Sem aquele arquivo, compra do mesmo jeito.
   Se algo falhar depois de o kit entrar, vai para /cart (que repassa ao
   checkout) em vez de adicionar de novo; se nada entrou, envio nativo. */
(function(){
  var form = document.getElementById('hs-buy');
  if (!form || !window.fetch) return;
  var EBOOK = parseInt(form.getAttribute('data-ebook'), 10) || 0;

  form.addEventListener('submit', function(e){
    var id = form.querySelector('input[name="id"]');
    if (!id) return;
    e.preventDefault();

    var cs = window.carrinhoSubstitui;
    if (cs && cs.ocupado()) return;

    var vid = parseInt(id.value, 10);
    var ctrl = new AbortController();
    var t = setTimeout(function(){ ctrl.abort(); }, 6000);
    var added = false;
    var btn = form.querySelector('.hs-cta');
    if (btn) btn.setAttribute('aria-busy', 'true');

    function post(url, body){
      return fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body),
        signal: ctrl.signal
      }).then(function(r){ if (!r.ok) throw new Error(r.status); return r; });
    }
    function passo(){
      return post('/cart/add.js', {items: [{id: vid, quantity: 1}]})
        .then(function(){
          added = true;
          if (!EBOOK) return;
          var u = {}; u[EBOOK] = 1;
          return post('/cart/update.js', {updates: u});
        });
    }
    var esperado = [{id: vid, quantity: 1}];
    if (EBOOK) esperado.push({id: EBOOK, quantity: 1});

    (cs ? cs.substituir(passo, esperado) : passo())
      .then(function(){ clearTimeout(t); location.href = '/checkout'; })
      .catch(function(){
        clearTimeout(t);
        if (added) location.href = '/cart';
        else form.submit();
      });
  });
})();

/* prova social (19/10/2026) */

/* "People trust": comentarios paginados de 3 em 3 */
(function(){
  document.querySelectorAll('[data-hs-pager]').forEach(function(box){
    var track = box.querySelector('[data-hs-pager-track]');
    var prev = box.querySelector('[data-hs-pager-prev]');
    var next = box.querySelector('[data-hs-pager-next]');
    if (!track || !next) return;
    var n = track.children.length;
    /* a pagina atual sai da posicao, nao de um contador: sobrevive a rolagem manual */
    function cur(){ return Math.round(track.scrollLeft / track.clientWidth); }
    function go(k){ track.scrollTo({left: ((k + n) % n) * track.clientWidth}); }
    next.addEventListener('click', function(){ go(cur() + 1); });
    if (prev) prev.addEventListener('click', function(){ go(cur() - 1); });
  });
})();

/* carrossel de cartoes com pontos */
(function(){
  var track = document.querySelector('[data-hs-dots-track]');
  var dots = document.querySelector('[data-hs-dots]');
  if (!track || !dots) return;
  var cards = track.children;
  if (cards.length < 2) return;
  for (var k = 0; k < cards.length; k++) dots.appendChild(document.createElement('i'));
  function sync(){
    var mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = 1e9;
    for (var k = 0; k < cards.length; k++) {
      var c = cards[k].offsetLeft + cards[k].offsetWidth / 2 - track.offsetLeft;
      if (Math.abs(c - mid) < dist) { dist = Math.abs(c - mid); best = k; }
    }
    dots.querySelectorAll('i').forEach(function(d, k){ d.classList.toggle('is-on', k === best); });
  }
  track.addEventListener('scroll', function(){ requestAnimationFrame(sync); }, {passive: true});
  sync();
})();

/* videos UGC: tocam num player em tela cheia */
(function(){
  var modal = document.getElementById('hs-video-modal');
  if (!modal) return;
  var player = modal.querySelector('[data-hs-vplayer]');
  function close(){
    player.pause(); player.removeAttribute('src'); player.load();
    modal.hidden = true; document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-hs-video]').forEach(function(b){
    b.addEventListener('click', function(){
      var src = b.getAttribute('data-hs-video');
      if (!src) return;
      player.src = src;
      modal.hidden = false; document.body.style.overflow = 'hidden';
      var p = player.play(); if (p && p.catch) p.catch(function(){});
    });
  });
  modal.querySelector('[data-hs-vclose]').addEventListener('click', close);
  modal.addEventListener('click', function(e){ if (e.target === modal) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) close(); });
})();
